export const extractDateKey = (date: string): string => {
	return date.split('T')[0];
};

export const filterByTimeframe = <T extends { timeframe_days?: number | null }>(
	products: (T | null)[],
	timeframe?: number
): T[] => {
	if (!timeframe) {
		return products.filter((product): product is T => product !== null);
	}

	return products.filter(
		(product): product is T => product !== null && product.timeframe_days === timeframe
	);
};
